import { AutomatedAction } from '../automated-action/automated-action.types';
import { PipelinePlacement } from '../placement/placement.types';

export enum StageCategory {
  None = 'none',
  Apply = 'apply',
  PhoneScreen = 'phone_screen',
  Interview = 'interview',
  Evaluation = 'evaluation',
  Offer = 'offer',
  Hire = 'hire',
  Referred = 'referred',
  Sourced = 'sourced',
}

export enum PipelineView {
  Qualified = 'qualified',
  Disqualified = 'disqualified',
}

export enum StageGroup {
  Applicants = 'applicants',
  Active = 'active',
  Hires = 'hires',
  Other = 'other',
}

export type StageGroupValue = `${StageGroup}`;

export interface Stage {
  id: number;
  name: string;
  category: StageCategory;
  group: StageGroup;
  position: number;
  locked: boolean;
  createdAt: string;
  updatedAt: string;
  actionTemplates: AutomatedAction[];
  timeLimit: number | null;
  placementsCount: number;
  fairEvaluationsEnabled: boolean;
}

export interface PipelineStage extends Stage {
  placements: PipelinePlacement[];
}

export interface StageReference extends Stage {
  type: 'Stage';
}

export type AdjustPipelineOption =
  | 'with_name'
  | 'with_created_at'
  | 'with_evaluations'
  | 'with_notes_count'
  | 'with_tasks_count'
  | 'with_upcoming_events'
  | 'with_overdue_at'
  | 'with_social_links'
  | 'with_tags'
  | 'with_integrations'
  | 'with_last_activity_at'
  | 'with_job_fit_score'
  | 'with_locations';

export type PipelineParams = {
  sort_by: string | undefined | null;
  sort_order: string | undefined | null;
  qualified: boolean;
  disqualified?: boolean;
  with_created_at?: boolean;
  with_evaluations?: boolean;
  with_integrations?: boolean;
  with_last_activity_at?: boolean;
  with_name?: boolean;
  with_notes_count?: boolean;
  with_overdue_at?: boolean;
  with_social_links?: boolean;
  with_tags?: boolean;
  with_tasks_count?: boolean;
  with_upcoming_events?: boolean;
  with_job_fit_score?: boolean;
  with_locations?: boolean;
};

export type PipelineParamsWithStage = PipelineParams & { stage_id: number };
